// import router from 'vue-router'
import store from '../store/index'
import { platformMap } from './socialPlatformMap.json'

const Util = {
  getAllPermissions () {
    let permissions = JSON.parse('[{"name":"盈店CRM","code":"A"},{"name":"我的客户","code":"AB"},{"name":"新增客户","code":"ABA"},{"name":"删除客户","code":"ABB"},{"name":"导入客户","code":"ABF"},{"name":"查看客户","code":"ABE"},{"name":"公海客户","code":"AJ"},{"name":"新增公海客户","code":"AJA"},{"name":"删除公海客户","code":"AJB"},{"name":"导入公海客户","code":"AJC"},{"name":"查看公海客户","code":"AJD"},{"name":"我的联系人","code":"AA"},{"name":"新增联系人","code":"AAA"},{"name":"删除联系人","code":"AAB"},{"name":"导入联系人","code":"AAC"},{"name":"导出联系人","code":"AAD"},{"name":"查看联系人","code":"AAF"},{"name":"合并联系人","code":"AAG"},{"name":"公海联系人","code":"AC"},{"name":"新增公海联系人","code":"ACA"},{"name":"删除公海联系人","code":"ACB"},{"name":"查看公海联系人","code":"ACC"},{"name":"导出公海联系人","code":"ACD"},{"name":"导入公海联系人","code":"ACE"},{"name":"报价单","code":"AE"},{"name":"订单","code":"AF"},{"name":"产品","code":"AG"},{"name":"审批","code":"AH"},{"name":"线索池","code":"AI"},{"name":"CRM工作台","code":"AD"},{"name":"盈店营销","code":"B"},{"name":"社媒营销","code":"BA"},{"name":"社媒发帖","code":"BAA"},{"name":"社交监控","code":"BAB"},{"name":"我的主页","code":"BAC"},{"name":"邮件营销","code":"BB"},{"name":"活动营销","code":"BC"},{"name":"成效分析","code":"BF"},{"name":"社媒报告","code":"BFC"},{"name":"主页成效","code":"BFA"},{"name":"盈店探索","code":"C"},{"name":"外贸侦探","code":"CA"},{"name":"询盘池","code":"CB"},{"name":"社交搜寻","code":"CD"},{"name":"海关数据","code":"CE"},{"name":"社媒雷达","code":"CF"},{"name":"邓白氏联盟","code":"CJ"},{"name":"客源搜索","code":"CK"},{"name":"盈店SHOP","code":"D"},{"name":"官网设置","code":"DA"},{"name":"产品管理","code":"DAD"},{"name":"分组管理","code":"DAC"},{"name":"官网风格","code":"DAB"},{"name":"页面管理","code":"DAA"},{"name":"官网统计","code":"DB"},{"name":"博客","code":"DC"},{"name":"智能作家","code":"DCA"},{"name":"博客","code":"DCB"},{"name":"我的订单","code":"DD"},{"name":"订单管理","code":"DDA"},{"name":"物流资金","code":"DE"},{"name":"物流管理","code":"DEA"},{"name":"资金管理","code":"DEB"},{"name":"其他设置","code":"F"},{"name":"素材库","code":"FB"},{"name":"图源搜索","code":"FC"},{"name":"邮件","code":"FD"},{"name":"小程序","code":"FE"},{"name":"Messenger监控","code":"FF"},{"name":"系统消息","code":"FG"},{"name":"系统中心","code":"E"},{"name":"绑定账号","code":"EA"},{"name":"关键字设置","code":"EB"},{"name":"消息接收类型管理","code":"EC"},{"name":"成效关键字设置","code":"ED"},{"name":"工作台","code":"I"},{"name":"盈店诊断","code":"K"}]')
    return permissions
  },
  checkUrl: function (url) {
    if (url) {
      if (url.substr(0, 8).toLowerCase() !== 'https://') {
        return url.substr(0, 7).toLowerCase() === 'http://' ? url : 'http://' + url
      } else {
        return url
      }
    } else {
      return ''
    }
  },
  /**
   * 判断当前增值服务是否开通
   * @param string
   * 1:邮件数量、2:外贸侦探任务量、3:子账号数量、4:vip询盘、5:官网挖掘、6:领英探查、7:多维搜寻
   * DOMAIN_SEARCH: 官网挖掘、 LINKEDIN_SEARCH: 领英探查、 DETAIL_SEARCH: 多维搜寻
  */
  hasRightByServiceCode: function (code) {
    let service = JSON.parse(window.localStorage.servicePermission || '{}')
    if (service.DOMAIN_SEARCH && code === 'D5') {
      return true
    }
    if (service.LINKEDIN_SEARCH && code === 'D6') {
      return true
    }
    if (service.DETAIL_SEARCH && code === 'D7') {
      return true
    }
    if (service.DB_ALLIANCE && code === 'D8') {
      return true
    }
    if (code === '') {
      return true
    }
    return false
  },
   /**
   * 当前权限是否在权限数组里
   * @param  {[type]}  thisRight  [description]
   * @param  {[type]}  rightArray [description]
   * @return {Boolean}            [description]
   */
  hasRightByCode: function (code) {
    // 9.11 主账号加入权限系统
    let isMainAccount = localStorage.isMainAccount === 'true' ? 1 : 0
    let func = JSON.parse(localStorage.getItem('functions'))
    let oService = localStorage.getItem('o-service')
    if (oService && (code === '' || code === 'CJ' || code === 'CK')) {
      return true
    }
    if (isMainAccount && !func.length) return true
    let modular = JSON.parse(window.localStorage.modularList || '{}')
    if (modular.crm && (modular.shop || modular.develop) && (code === 'FE')) {
      return true
    }
    let rightArray = JSON.parse(localStorage.functions || '[]')
    let isIn = rightArray.some(function (it) {
      return it.code === code
    })
    /**
     * 如果 thisRight.code 是空  【工作台的code为空】，默认显示
     * @param  {[type]} thisRight.code [description]
     * @return {[type]}                [description]
     */
    if (code === '' || code === 'K') {
      return true
    } else {
      return isIn
    }
  },
  // 偏移量
  Noitpyrcne (str) {
    let strA = JSON.parse(Util.b64DecodeUnicode(str))
    let strE = strA.join('_').replace(/_/g, 'M')
    return Util.b64DecodeUnicode(strE)
  },
  // 添加联系人权限判断
  modularCheck (checkType) {
    let modular = window.localStorage.modularList
    modular = JSON.parse(modular)
    if (!checkType) {
      if (modular.crm) {
        return true
      } else {
        store.commit('MODULAR_DIALOG', { isModularDialog: true, isModularType: 'crm' })
        return false
      }
    } else {
      if (!modular.crm && (modular.develop || modular.shop)) {
        return 1
      } else if (modular.crm && (modular.develop || modular.shop)) {
        return 2
      } else if (!modular.crm && !modular.develop && !modular.shop) {
        store.commit('MODULAR_DIALOG', { isModularDialog: true, isModularType: 'crm' })
        return 3
      }
    }
  },
  // 近几天
  nearFutureDays (num) {
    let time = new Date()
    time.setDate(time.getDate() - num)
    let timeList = new Date(time)
    return timeList
  },
  // 未来几天
  FutureDays (arg, num) {
    let time = new Date(arg)
    time.setDate(time.getDate() + num)
    let timeList = new Date(time)
    return timeList
  },
  setCookie (name, value, day) {
    var setting = arguments[1]
    if (Object.prototype.toString.call(setting).slice(8, -1) === 'Object') {
      for (var i in setting) {
        let oDate = new Date()
        oDate.setDate(oDate.getDate() + day)
        document.cookie = i + '=' + setting[i] + ';expires=' + oDate
      }
    } else {
      let oDate = new Date()
      oDate.setDate(oDate.getDate() + day)
      document.cookie = name + '=' + value + ';expires=' + oDate
    }
  },
  getCookie (name) {
    var arr = document.cookie.split('; ')
    for (var i = 0; i < arr.length; i++) {
      var arr2 = arr[i].split('=')
      if (arr2[0] === name) {
        return arr2[1]
      }
    }
    return ''
  },
   /**
   * 接口时间格式化
   * @param  {[Date]}  time  [description]
   * @return {string}          [description]
   */
  dataFormat (time) {
    let year = time.getFullYear()
    let month = (time.getMonth() < 9 ? '0' : '') + (time.getMonth() + 1)
    let day = (time.getDate() < 10 ? '0' : '') + time.getDate()
    return year + '-' + month + '-' + day
  },
  // 时间格式化
  timeFormart (time) {
    let year = time.getFullYear()
    let month = (time.getMonth() < 9 ? '0' : '') + (time.getMonth() + 1)
    let day = (time.getDate() < 10 ? '0' : '') + time.getDate()
    let hour = (time.getHours() < 10 ? '0' : '') + time.getHours()
    let minute = (time.getMinutes() < 10 ? '0' : '') + time.getMinutes()
    let second = (time.getSeconds() < 10 ? '0' : '') + time.getSeconds()
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
  },
  // 时间格式化
  timeFormartNohour (time) {
    let year = time.getFullYear()
    let month = (time.getMonth() < 9 ? '0' : '') + (time.getMonth() + 1)
    let day = (time.getDate() < 10 ? '0' : '') + time.getDate()
    return year + '-' + month + '-' + day
  },
  // 获取基于当天的前几天和后几天, 返回二维数组，分别是年月日和时分秒
  getDateTime (day, pos, monthAdd) {
    /**
     * pos : true： 向后推day天，  false: 向前推day天。
     * day 差异天数
     * monthAdd 是否对月份进行加1
     */
    let milliseconds = day * 24 * 60 * 60 * 1000
    let currMilliseconds = (new Date()).getTime()
    let diffcurrMilliseconds = 0
    let dateFomat = ''
    if (pos) {
      diffcurrMilliseconds = currMilliseconds + milliseconds
    } else {
      diffcurrMilliseconds = currMilliseconds - milliseconds
    }
    dateFomat = new Date(diffcurrMilliseconds)
    let year = dateFomat.getFullYear()
    let mounth = (dateFomat.getMonth() < 9 ? '0' : '') + (dateFomat.getMonth() + (monthAdd ? 1 : 0))
    let dayC = (dateFomat.getDate() < 10 ? '0' : '') + dateFomat.getDate()
    let hour = (dateFomat.getHours() < 10 ? '0' : '') + dateFomat.getHours()
    let minute = (dateFomat.getMinutes() < 10 ? '0' : '') + dateFomat.getMinutes()
    let second = (dateFomat.getSeconds() < 10 ? '0' : '') + dateFomat.getSeconds()
    let allDate = [
      [year, mounth, dayC],
      [hour, minute, second]
    ]
    return allDate
  },
  GetDateDiff (startDate, endDate) {
    var startTime = new Date(startDate).getTime()
    var endTime = new Date(endDate).getTime()
    var dates = Math.abs((startTime - endTime)) / (1000 * 60 * 60 * 24)
    return dates
  },
  getPageSize (count, size) {
    let pageNum = 0
    if (count > 0) {
      let pages = Math.ceil(count / size)
      pageNum = pages > 5 ? 5 : pages < 1 ? 1 : pages
    } else {
      pageNum = 0
    }
    return pageNum
  },
  // 判断对象是否完全相等
  objMatch (x, y) {
    if (x === y) {
      return true
    }
    if (!(x instanceof Object) || !(y instanceof Object)) {
      return false
    }
    if (x.constructor !== y.constructor) {
      return false
    }
    for (var p in x) {
      if (x.hasOwnProperty(p)) {
        if (!y.hasOwnProperty(p)) {
          return false
        }
        if (x[p] === y[p]) {
          continue
        }
        if (typeof (x[p]) !== 'object') {
          return false
        }
        if (!Object.equals(x[p], y[p])) {
          return false
        }
      }
    }
    for (p in y) {
      if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) {
        return false
      }
    }
    return true
  },
  // 获取字符串真实长度(中文两个字符,英文一个字符)
  getStrLength (str) {
    if (str == null) return 0
    if (typeof str !== 'string') str += ''
    return str.replace(/[^\x00-\xff]/g, '01').length
  },
  // 渠道列表
  getChannelId () {
    let channelList = window.localStorage.channelList ? JSON.parse(window.localStorage.channelList) : []
    let channel = {
      fb: '',
      tw: '',
      lk: '',
      pin: '',
      ma: ''
    }
    channelList.forEach((item) => {
      if (item.channelId === 'FACEBOOK' && item.bindingTag === 1) {
        channel.fb = item.homePageId || ''
      } else if (item.channelId === 'TWITTER' && item.bindingTag === 1) {
        channel.tw = item.nickName || ''
      } else if (item.channelId === 'LINKEDIN' && item.bindingTag === 1 && item.homePageId) {
        channel.lk = 'company/' + item.homePageName || ''
      } else if (item.channelId === 'LINKEDIN' && item.bindingTag === 1) {
        // 此处需要获取用户lk-id
        // channel.tw = 'in/' + item.nickName.replace(' ', '-') + '-' + item.provideUserId
      }
    })
    return channel
  },
  // base64解码
  b64EncodeUnicode (str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode('0x' + p1)
    }))
  },
  // base64编码
  b64DecodeUnicode (str) {
    return decodeURIComponent(atob(str).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
  },
  // 社交平台图标枚举 - 获取颜色
  getSocialColor (p) {
    let list = platformMap
    return list.find(n => n.platform === p).color
  },
  // 社交平台图标枚举 - 获取图标
  getSocialIcon (p) {
    let list = platformMap
    return list.find(n => n.platform === p).icon
  }
}
export default Util
export function deepClone (source) {
  const targetObj = source.constructor === Array ? [] : {}
  for (const keys in source) {
    if (source.hasOwnProperty(keys)) {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = source[keys].constructor === Array ? [] : {}
        targetObj[keys] = deepClone(source[keys])
      } else {
        targetObj[keys] = source[keys]
      }
    }
  }
  return targetObj
}
export function timeLineFuc (timeLineByTime, datas, type) {
  datas.forEach(record=> {
    let year = (new Date(record[type])).getFullYear()
    let month = (new Date(record[type])).getMonth() + 1
    let initArray = []
    if (timeLineByTime.length === 0) {
      initArray.push(record)
      timeLineByTime.push({
        month: month,
        year: year,
        container: initArray
      })
    } else {
      timeLineByTime.forEach((timeRecord, j) => {
        // console.log(timeRecord.year, year, timeRecord.month, month, 'month-month')
        if (timeRecord.year === year && timeRecord.month === month) {
          timeRecord.container.push(record)
        } else if (j === (timeLineByTime.length - 1)) {
          initArray.push(record)
          timeLineByTime.push({
            month: month,
            year: year,
            container: initArray
          })
        }
      })
    }
  })
  return timeLineByTime
}
export function getByteLen (val) { // 统计字符个数(英文1个字符，中文2两个字符处理) OMG,方法重了getStrLength (shit!!!)
  let len = 0
  let newVal = typeof val === 'string' ? val : ''
  for (let i = 0; i < newVal.length; i++) {
    let length = newVal.charCodeAt(i)
    if (length >= 0 && length <= 128) {
      len += 1
    } else {
      len += 2
    }
  }
  return len
}
  /**
 * 正则匹配String中的网址并截取字符窜前 n 个字符 超出部分...
 * @param  {[value]}  String  [目标字符串]
 * @param  {[cutLen]}  Number  [截取长度]
 * @param  {[canLink]}  Boolean  [是否支持链接跳转]
 * @return {html}          [包含html的字符串]
 */
export function handleLongStr (value, cutLen, canLink) {
  let len = getByteLen(value)
  let strRegex = '((https|http)://)[A-Za-z0-9.-_]+\\.[A-Za-z0-9-_%&?/.=]+'
  let regex = new RegExp(strRegex, 'gi')
  let returnTxt = value
  if (value === null) {
    return returnTxt
  } else {
    returnTxt = value.replace(regex, function (m) {
      let opa = canLink ? `href=${m}` : `javascript:;`
      return '<a class="view-link" ' + opa + '" target="_blank">' + m + '</a>'
    })
  }
  if (len > cutLen) {
    return returnTxt.substring(0, cutLen) + '...'
  } else {
    return returnTxt
  }
}
  /**
 * 在光标处插入文本
 * @param  {[myField]}  DOM  [目标DOM]
 * @param  {[myValue]}  String  [需要插入的文本]
 * @return {String}          [返回插入后的字符串]
 */
export function insertAtCursor (myField, myValue) { // 在光标处插入文本
  // IE 浏览器
  if (document.selection) {
    myField.focus()
    let sel = document.selection.createRange()
    sel.text = myValue
    sel.select()
  } else if (myField.selectionStart || myField.selectionStart === '0') { // FireFox、Chrome等
    let startPos = myField.selectionStart
    let endPos = myField.selectionEnd
    // 保存滚动条
    let restoreTop = myField.scrollTop
    myField.value = myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length)
    if (restoreTop > 0) {
      myField.scrollTop = restoreTop
    }
    myField.focus()
    myField.selectionStart = startPos + myValue.length
    myField.selectionEnd = startPos + myValue.length
  } else {
    myField.value += myValue
    myField.focus()
  }
  return myField.value
}
export async function getVideoTime (file, callBack) { // 获取视频时长
  let url = URL.createObjectURL(file)
  let audioElement = new Audio(url)
  file.duration = 0
  audioElement.addEventListener('loadedmetadata', await function (_event) {
    file.duration = audioElement.duration
    callBack ? callBack() : null
  })
}
